import {
  ArrowLineUpRightIcon,
  GridPresetOneThird,
  GridRow,
  HideFor,
  Link,
  OptimizelyEditProperty,
} from "/App.Components";
import { RssNewsBlockProps } from "/Models/Generated/RssNewsBlockProps";
import "./RssNewsBlock.scss";
import { RowSpacing } from "../../Layout/GridRow/GridRow";
import { ColorTheme } from "/Models/Models/ColorTheme";
import cn from "classnames";

const RssNewsBlock = ({
  heading,
  panoramaLink,
  rssNewsItems,
  publishedLabel,
  noItemsMessage,
  openExternalLinkAriaLabel,
}: RssNewsBlockProps) => {
  return (
    <div className="rss-news-block-norad">
      <div className="rss-news-block-norad__block-top">
        <OptimizelyEditProperty propertyName={heading}>
          {heading && (
            <h2 className="rss-news-block-norad__heading">{heading}</h2>
          )}
        </OptimizelyEditProperty>
        <div className={cn("rss-news-block-norad__read-more")}>
          {panoramaLink && (
            <>
              <HideFor mobile tablet>
                <Link
                  {...panoramaLink}
                  icon={ArrowLineUpRightIcon}
                  iconPlacement="after"
                  size="small"
                />
              </HideFor>
              <HideFor desktop desktopMedium desktopLargeUp>
                <Link
                  {...panoramaLink}
                  icon={ArrowLineUpRightIcon}
                  iconPlacement="after"
                  size="x-small"
                />
              </HideFor>
            </>
          )}
        </div>
      </div>
      {rssNewsItems && (
        <GridRow rowSpacing={RowSpacing.l}>
          {rssNewsItems.map((item, idx) => (
            <GridPresetOneThird key={"rssNewsItem" + idx}>
              <a
                className="rss-news-block-norad__link"
                target={item.newsLink?.isExternal ? "_blank" : undefined}
                href={item.newsLink?.href}
              >
                <div className="rss-news-block-norad__link-top-row">
                  <div className="rss-news-block-norad__text">
                    <h3 className="rss-news-block-norad__item-heading">
                      <span>{item.newsLink?.text}</span>
                    </h3>
                    {item.newsLink?.isExternal && (
                      <ArrowLineUpRightIcon
                        size="20"
                        thickness="Reg"
                        color={ColorTheme.default}
                        ariaLabel={openExternalLinkAriaLabel}
                      />
                    )}
                  </div>
                </div>
                <div className="rss-news-block-norad__link-bottom-row">
                  <span className="rss-news-block-norad__published">
                    {publishedLabel + ":"} {item.publishedDate}
                  </span>
                </div>
              </a>
            </GridPresetOneThird>
          ))}
        </GridRow>
      )}
      {!rssNewsItems ||
        (rssNewsItems?.length === 0 && noItemsMessage && (
          <p className="rss-news-block-norad__no-results">{noItemsMessage}</p> //<-- midlertidig håndtering, sjekk med design
        ))}
    </div>
  );
};

export default RssNewsBlock;
